

export function calculateHaversineDistance([latitude1, longitude1], [latitude2, longitude2]) {
  const converterParaRadianos = grau => (grau * Math.PI) / 180;

  const raioTerraMetros = 6371000; // Raio médio da Terra em metros

  const latitude1Rad = converterParaRadianos(latitude1);
  const latitude2Rad = converterParaRadianos(latitude2);
  
  const diferencaLatitudeRad = converterParaRadianos(latitude2 - latitude1);
  const diferencaLongitudeRad = converterParaRadianos(longitude2 - longitude1);

  const a =
    Math.sin(diferencaLatitudeRad / 2) ** 2 +
    Math.cos(latitude1Rad) * Math.cos(latitude2Rad) *
    Math.sin(diferencaLongitudeRad / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distancia = raioTerraMetros * c;

  return distancia;

}